import React, { useState } from "react"
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import AHMIS, { API_URL } from "../../../api/api";
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import AddAlertMessage from "../../../components/alert/Alert";
import ReportHeader from "../component/report-header/ReportHeader";
import MessageBlock from "../../admin/components/message-block/MessageBlock";

const JesthaNagrikSewaReport = () => {

  const [tableData, setTableData] = useState({});

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.jesthanagarikReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url)
      .then(response => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTableData(jsondata.data);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
      });
  };

  return (
    <>
      <ReportHeader
        title="जेष्ठ नागरिक सेवा प्रतिबेदन"
        getReportData={getReportData}
      />
      {Object.keys(tableData).length > 0 ? (
        <>
          <TableContainer classes={{ root: "fixed-head-table-container" }}  >
            <Typography variant="body1" className="report-heading">जेष्ठ नागरिक सेवा प्रतिवेदन</Typography>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Jestha Nagrik Sewa">
              <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                <TableRow>
                  <TableCell rowSpan={3}>सेवाको प्रकार अनुसार सेवा लिएको विवरण</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={3}>स्नेहन </TableCell>
                  <TableCell colSpan={3}>स्वेदन</TableCell>
                  <TableCell colSpan={3}>रसायन औषधि /तेल</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>महिला </TableCell>
                  <TableCell>पुरूष </TableCell>
                  <TableCell>अन्य </TableCell>
                  <TableCell>महिला </TableCell>
                  <TableCell>पुरूष </TableCell>
                  <TableCell>अन्य </TableCell>
                  <TableCell>महिला </TableCell>
                  <TableCell>पुरूष </TableCell>
                  <TableCell>अन्य </TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell>नयाँ सेवाग्राही संख्या</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.NEW_PATIENT["1"]?.FEMALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.NEW_PATIENT["1"]?.MALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.NEW_PATIENT["1"]?.OTHER}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.NEW_PATIENT["2"]?.FEMALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.NEW_PATIENT["2"]?.MALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.NEW_PATIENT["2"]?.OTHER}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.NEW_PATIENT["3"]?.FEMALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.NEW_PATIENT["3"]?.MALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.NEW_PATIENT["3"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>पुनरावृत सेवाग्राही संख्या</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["1"]?.FEMALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["1"]?.MALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["1"]?.OTHER}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["2"]?.FEMALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["2"]?.MALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["2"]?.OTHER}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["3"]?.FEMALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["3"]?.MALE}</TableCell>
                  <TableCell>{tableData?.jesthaNagarikSewa?.PREVIOUS_PATIENT["3"]?.OTHER}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box mt={2}>
            <TableContainer classes={{ root: "fixed-head-table-container" }}  >
              <Typography variant="body1" className="report-heading">उमेर अनुसार सेवा प्रतिबेदन</Typography>
              <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Jestha Nagrik Sewa">
                <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                  <TableRow>
                    <TableCell rowSpan={3}>उमेर समूह वर्ष/सेवा</TableCell>
                    <TableCell colSpan={3}>नयाँ सेवाग्राही मात्र</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>रसायन औषधि /तेल</TableCell>
                    <TableCell>स्नेहन </TableCell>
                    <TableCell>स्वेदन </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody classes={{ root: "align-center" }}>
                  <TableRow>
                    <TableCell>६० देखि ६९</TableCell>
                    <TableCell>{tableData?.ageGroupService?.["60-69"]?.["1"]}</TableCell>
                    <TableCell>{tableData?.ageGroupService?.["60-69"]?.["2"]}</TableCell>
                    <TableCell>{tableData?.ageGroupService?.["60-69"]?.["3"]}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>७० देखि ७९</TableCell>
                    <TableCell>{tableData?.ageGroupService?.["70-79"]?.["1"]}</TableCell>
                    <TableCell>{tableData?.ageGroupService?.["70-79"]?.["2"]}</TableCell>
                    <TableCell>{tableData?.ageGroupService?.["70-79"]?.["3"]}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>८० देखि ८४</TableCell>
                    <TableCell>{tableData?.ageGroupService?.["80-84"]?.["1"]}</TableCell>
                    <TableCell>{tableData?.ageGroupService?.["80-84"]?.["2"]}</TableCell>
                    <TableCell>{tableData?.ageGroupService?.["80-84"]?.["3"]}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>>=८५ वर्ष</TableCell>
                    <TableCell>{tableData?.ageGroupService?.[">=85"]?.["1"]}</TableCell>
                    <TableCell>{tableData?.ageGroupService?.[">=85"]?.["2"]}</TableCell>
                    <TableCell>{tableData?.ageGroupService?.[">=85"]?.["3"]}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box mt={2}>
            <TableContainer classes={{ root: "fixed-head-table-container" }}  >
              <Typography variant="body1" className="report-heading">सेवाग्राही अनुसारको विवरण</Typography>
              <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Jestha Nagrik Sewa">
                <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                  <TableRow>
                    <TableCell colSpan={2}>सेवाग्राही अनुसारको विवरण</TableCell>
                    <TableCell>नयाँ</TableCell>
                    <TableCell>पुनरावृत</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody classes={{ root: "align-center" }}>
                  <TableRow>
                    <TableCell rowSpan={4}>जेष्ठ नागरिक सेवाग्राही संख्या</TableCell>
                    <TableCell>महिला</TableCell>
                    <TableCell>{tableData?.serviceRecipientDetails?.NEW_PATIENT?.FEMALE}</TableCell>
                    <TableCell>{tableData?.serviceRecipientDetails?.PREVIOUS_PATIENT?.FEMALE}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>पुरुष</TableCell>
                    <TableCell>{tableData?.serviceRecipientDetails?.NEW_PATIENT?.MALE}</TableCell>
                    <TableCell>{tableData?.serviceRecipientDetails?.PREVIOUS_PATIENT?.MALE}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>अन्य</TableCell>
                    <TableCell>{tableData?.serviceRecipientDetails?.NEW_PATIENT?.OTHER}</TableCell>
                    <TableCell>{tableData?.serviceRecipientDetails?.PREVIOUS_PATIENT?.OTHER}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>जम्मा</TableCell>
                    <TableCell>{tableData?.serviceRecipientDetails?.NEW_PATIENT?.TOTAL}</TableCell>
                    <TableCell>{tableData?.serviceRecipientDetails?.PREVIOUS_PATIENT?.TOTAL}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  )
}

export default JesthaNagrikSewaReport;